import { fromJS } from 'immutable';

import {ApiUrl2, ClientId, DivisionId, PrevilageId, UserToken} from '../../../helper/HelperAuth'
import { GetUserAll } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (isadmin) => async (dispatch, getState) => {
    
    const Authorization = UserToken;
    
    const url = ApiUrl2 + 'user-list';

    let client_id = ClientId;
    let divisionId = DivisionId;
    if (PrevilageId == 1 || isadmin == true) {
        client_id = 0;
        divisionId = 0;
    }

    let bodyFInd = {
        "client-id": client_id,
        "division-id": divisionId,
        "sender-id": [""],
        "username": "",
        "group-id":0
    }

    var paramBody = {
        "query":{
            "search":bodyFInd,
            "page":1,
            "page-size":100000,
            "order-by":1,
            "order":"ASC"
        }
    };
    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };  

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
        data = data.get('data');
    }

    dispatch({ type: GetUserAll, data: fromJS(data) });
};